import { CATALOGUE } from '../data/catalogue';
import { COLLECTIONS } from '../data/collections';

// True on a product page. Product pages carry their own sticky bar on phones
// (price, Add, Buy now), so the floating call and WhatsApp buttons stay out
// of the way there instead of sitting on top of it.

const PRODUCT_PATHS = new Set(CATALOGUE.map((m) => `/${m.slug}`));

const clean = (pathname = '') => pathname.replace(/\/+$/, '') || '/';

export function isProductPath(pathname = '') {
  const p = clean(pathname);
  // Old-stock unit pages (/clearance-ac-sale/<unit>) are product pages too.
  return PRODUCT_PATHS.has(p) || p.startsWith('/daikin-ac/') || p.startsWith('/clearance-ac-sale/');
}

// Pages with their own sticky bar on phones: product pages, and the AC
// calculator (Calculate / Edit room, with WhatsApp in the bar). The floating
// call and WhatsApp buttons hide on phones on these pages.
export function hasStickyBar(pathname = '') {
  const p = clean(pathname);
  return isProductPath(p) || p === '/ac-calculator';
}

// The shop: the price list, the collection pages (1.5 Ton, 5 Star ...),
// product pages, the cart and the paid HVAC consultation. Buying online is what these pages are for, so
// calling is available but not pushed: no floating call or WhatsApp buttons
// on any screen size, and a quiet Help menu in the header on phones instead.
const SHOP_PATHS = new Set([
  '/daikin-ac-price-list-delhi',
  '/cart',
  '/hvac-consultant',
  ...COLLECTIONS.map((c) => `/${c.slug}`),
]);

// The compare tool and its size and pair pages are buy pages too.
const isComparePath = (p) => p === '/compare-ac' || p.startsWith('/compare/') || /^\/compare-[\d-]+-ton-ac$/.test(p);

export function isShopPath(pathname = '') {
  const p = clean(pathname);
  return SHOP_PATHS.has(p) || isProductPath(p) || isComparePath(p);
}
